import React from "react";
import {ReviewWrapper} from "components/atoms/Store/Overview/Reviews/Review.styles";
import {FaArrowDown, FaArrowUp} from "react-icons/fa";
import {BarChart, Bar, XAxis, ResponsiveContainer, Tooltip} from "recharts";

const CustomBarShape = props => {
    const {x, y, width, maxWidth, height, fill} = props;
    const radius = 10; // Adjust this value to set the border radius

    return (
        <g>
            <rect x={x} y={y} width={width} maxWidth={maxWidth} height={height} fill={fill} rx={radius} ry={radius} />
        </g>
    );
};
const Reviews = () => {
    const positiveRevData = [
        {name: "Monday", PR: 88},
        {name: "Tuesday", PR: 108},
        {name: "Wednesday", PR: 140},
        {name: "Thursday", PR: 100},
        {name: "Friday", PR: 76},
    ];
    const ngativeRevData = [
        {name: "Monday", PR: 88},
        {name: "Tuesday", PR: 108},
        {name: "Wednesday", PR: 140},
        {name: "Thursday", PR: 100},
        {name: "Friday", PR: 76},
    ];

    return (
        <>
            <ReviewWrapper>
                <div className="text-wrapper">
                    <div className="heading">
                        <h2>Positive Review</h2>
                        <p>Oct 31, 2023, 12:02 PM</p>
                    </div>
                    <div className="Rating-wrapper">
                        <strong>This Month</strong>
                        <div className="review-info">
                            <strong>3,678</strong>
                            <span>Reviews</span>
                        </div>
                        <div className="positive-rating">
                            <FaArrowUp />
                            <span>+ 15%</span>
                        </div>
                    </div>
                </div>
                <ResponsiveContainer maxWidth={320} width="100%" height={230}>
                    <BarChart
                        width={320}
                        height={190}
                        data={positiveRevData}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}>
                        <Tooltip />
                        <XAxis dataKey="name" fontSize="9px" />
                        <Bar dataKey="PR" fill="#7DF500" barSize={16} shape={<CustomBarShape />} />
                    </BarChart>
                </ResponsiveContainer>
            </ReviewWrapper>
            <ReviewWrapper>
                <div className="text-wrapper">
                    <div className="heading">
                        <h2>Negative Review</h2>
                        <p>Oct 31, 2023, 12:02 PM</p>
                    </div>
                    <div className="Rating-wrapper">
                        <strong>This Month</strong>
                        <div className="review-info">
                            <strong>-365</strong>
                            <span>Reviews</span>
                        </div>
                        <div className="negative-rating">
                            <FaArrowDown />
                            <span>+ 15%</span>
                        </div>
                    </div>
                </div>
                <ResponsiveContainer maxWidth={320} width="100%" height={230}>
                    <BarChart
                        width={320}
                        height={190}
                        data={ngativeRevData}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}>
                        <Tooltip />
                        <XAxis dataKey="name" fontSize="9px" />
                        <Bar dataKey="PR" fill="#E00000" barSize={16} shape={<CustomBarShape />} />
                    </BarChart>
                </ResponsiveContainer>
            </ReviewWrapper>
        </>
    );
};

export default Reviews;
